import { Component, OnInit, Input, SimpleChanges } from "@angular/core";
import { ChartDataSets, ChartOptions } from "chart.js";
import { Color, Label } from "ng2-charts";
import { GraphicData } from "../../schema/graphic-data";

@Component({
    selector: "app-graphic-line",
    templateUrl: "./graphic-line.component.html",
    styleUrls: ["./graphic-line.component.scss"]
})
export class GraphicLineComponent implements OnInit {
    @Input("data")
    public data: GraphicData;

    public lineChartLabels: Label[];
    public lineChartData: ChartDataSets[];
    public lineChartPlugins: any[];
    public lineChartColors: Color[];
    public lineChartType: string;
    public lineChartLegend: boolean;
    public lineChartOptions: ChartOptions & { annotation: any };

    constructor() {
        this.lineChartLabels = [];
        this.lineChartData = [];
        this.lineChartPlugins = [];
        this.lineChartColors = [];
        this.lineChartType = "line";
        this.lineChartLegend = true;
        this.lineChartOptions = { responsive: true, annotation: "" };
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.data && JSON.stringify(changes.data.previousValue) != JSON.stringify(changes.data.currentValue)) {
            this.manageData(changes.data.currentValue);
        }
    }

    ngOnInit() {
        this.manageData(this.data);
    }

    private manageData(data: GraphicData) {
        this.lineChartLabels = [];
        this.lineChartData = [];

        if (data == undefined) return;

        if (data.keys.length <= 0) return;

        this.lineChartLabels = data.keys;

        data.group.forEach((group) => {
            this.lineChartData.push({
                data: group.values,
                label: group.group
            });
        });
    }
}
